import { Button } from '@platform/components';
import GoogleLogo from './google_logo.svg';

export const GoogleSignInButton = () => {
  const logInHref = import.meta.env.VITE_API_HOST + '/login/google';

  return (
    <div>
      <Button href={logInHref} variant='secondary-gray' size='lg' additionalClassnames='w-full'>
        <img src={GoogleLogo} /> {'Log in with Google'}
      </Button>
    </div>
  );
};
